import React from "react";
import ct from "class-types.macro";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import OutletOffer from "./Pricing/OutletOffer";

interface Props {
  product: PricingProduct;
}

const EverlivingProductDetailPricingBox = ({ product }: Props) => {
  const { outletOffer, price, unitOfMeasure } = product;

  return (
    <div id="subject" className="side-col ag-product">
      <div
        className={`ag-item box ${ct(
          "border-b-0",
          "py-5",
          "px-3-1/2",
          "md:border-b",
          "lt:px-5",
        )}`}
        id="priceBox"
      >
        <div className="pricing">
          <p className="price">
            {formatAsCurrency.formatIfUndefined(price.price)}
            {unitOfMeasure && <span className="each">/{unitOfMeasure}</span>}
          </p>
          <p className={`price ${ct("text-lg-1/2", "mb-0", "text-gray-800")}`}>
            This product is no longer available. We&apos;ve left this page up
            for reference only.
          </p>
        </div>
        {outletOffer && (
          <OutletOffer
            price={outletOffer.price}
            link={outletOffer.link}
            hasMapStyle={
              price.displayMinimumAdvertisedPrice &&
              !!price.minimumAdvertisedPriceProperties?.type.trim()
            }
          />
        )}
      </div>
    </div>
  );
};

export default EverlivingProductDetailPricingBox;
